import React, {useState} from 'react';
import {Card, Button, Stack, Badge, TextStyle, Collapsible} from '@shopify/polaris';
import {useUserRole} from '../../contexts/userRoleContext';

/**
 * Development component to display current user role information
 * Only shows in development mode
 */
export default function DevRoleInfo() {
  const [isOpen, setIsOpen] = useState(false);
  const {user, userProfile, roles, apps, loading, error, isAuthenticated, isAdmin} = useUserRole();

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        maxWidth: '300px'
      }}
    >
      <Card>
        <Card.Section>
          <Button onClick={toggleOpen} fullWidth>
            🔐 Role Info {isOpen ? '▼' : '▶'}
          </Button>
        </Card.Section>

        <Collapsible open={isOpen}>
          <Card.Section>
            <Stack vertical spacing="tight">
              <div>
                <TextStyle variation="strong">Status:</TextStyle>
                <Stack spacing="extraTight">
                  <Badge status={isAuthenticated ? 'success' : 'critical'}>
                    {isAuthenticated ? 'Authenticated' : 'Not Authenticated'}
                  </Badge>
                  {isAdmin && <Badge status="warning">Admin</Badge>}
                  {loading && <Badge>Loading...</Badge>}
                </Stack>
              </div>

              {error && (
                <div>
                  <TextStyle variation="negative">Error: {error}</TextStyle>
                </div>
              )}

              {user && (
                <div>
                  <TextStyle variation="strong">User:</TextStyle>
                  <p style={{fontSize: '12px', wordBreak: 'break-all'}}>{user.email}</p>
                </div>
              )}

              {roles.length > 0 && (
                <div>
                  <TextStyle variation="strong">Roles:</TextStyle>
                  <Stack spacing="extraTight" wrap={false}>
                    {roles.slice(0, 3).map((role, index) => (
                      <Badge key={index} size="small">
                        {role.split(':')[1] || role}
                      </Badge>
                    ))}
                    {roles.length > 3 && (
                      <Badge size="small" status="info">
                        +{roles.length - 3}
                      </Badge>
                    )}
                  </Stack>
                </div>
              )}

              {apps.length > 0 && (
                <div>
                  <TextStyle variation="strong">Apps:</TextStyle>
                  <Stack spacing="extraTight" wrap={false}>
                    {apps.slice(0, 2).map((app, index) => (
                      <Badge key={index} size="small" status="success">
                        {app.appId}
                      </Badge>
                    ))}
                    {apps.length > 2 && (
                      <Badge size="small" status="info">
                        +{apps.length - 2}
                      </Badge>
                    )}
                  </Stack>
                </div>
              )}

              {userProfile && (
                <div>
                  <TextStyle variation="strong">Profile ID:</TextStyle>
                  <p style={{fontSize: '10px', wordBreak: 'break-all'}}>{userProfile.id}</p>
                </div>
              )}
            </Stack>
          </Card.Section>
        </Collapsible>
      </Card>
    </div>
  );
}
